import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { RisksPage } from '@/features/compliance-registers/risks'
import { requireActiveSubscription } from '@/lib/middleware'

// The selected risk lives in the URL, so a row somebody is looking at survives a
// reload and can be linked to from an obligation on the hub.
const searchSchema = z.object({
  risk: z.string().optional(),
  obligation: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/compliance/risks')({
  validateSearch: searchSchema,
  beforeLoad: async () => requireActiveSubscription(),
  component: RisksPage,
})
